/**
 * Copyright (c) 2018-2019 Aleksey Melnikov, True Directive Company.
 * @link https://truedirective.com/
 * @license MIT
*/
import { Component, Input, Output, EventEmitter, HostBinding,
         ChangeDetectorRef,
         ViewChild } from '@angular/core';

import { ColumnType, DetectionMode, SelectionMode } from '@true-directive/base';
import { Column } from '@true-directive/base';
import { FilterOperator, Filter } from '@true-directive/base';
import { GridSettings } from '@true-directive/base';
import { GridState } from '@true-directive/base';

import { MenuComponent } from '../../controls/menu.component';
import { FilterBaseComponent } from './filter-base.component';

import { InternationalizationService } from '../../internationalization/internationalization.service';

@Component({
  selector: 'true-filter-text',
  templateUrl: 'filter-text.component.html',
  styles: [`
    :host {
      display: block;
      width: 25em;
    }

    .true-filter-text {
      display: block;
      width: 100%;
    }

    .true-filter-text input {
      width: 100%;
    }

    .true-filter-text__options {
      padding: 0;
      margin: 0.8em 0 0 0.2em;
    }

    .true-filter-text__mode-selector {
      float: right;
    }

    p {
      padding: 0;
      margin: 0.6em 0 0 0;
    }

    .true-link {
      margin: 0 0.0em 0 0;
    }

    .true-filter-text__items {
      padding-top: 1.5em;
    }

    .true-filter-text__grid {
      transition: border-color 0.2s ease;
      display: block;
      width: 100%;
      height: 20em;
    }

    .grid-error {
      border-color: #a00;
    }
  `]
})
export class FilterTextComponent extends FilterBaseComponent {

  @Input() filter: Filter = null;
  @Input() rows: Array<any> = null;
  public state: GridState;


  // ÐÑÐ¸Ð±ÐºÐ° Ð¿Ð¾Ð»ÑÐ·Ð¾Ð²Ð°ÑÐµÐ»ÑÑÐºÐ¾Ð³Ð¾ Ð²Ð²Ð¾Ð´Ð°
  inputError: string = '';
  gridError: string = '';

  // Ð¡Ð¿Ð¸ÑÐ¾Ðº Ð²Ð¾Ð·Ð¼Ð¾Ð¶Ð½ÑÑ Ð¾Ð¿ÐµÑÐ°ÑÐ¾ÑÐ¾Ð² Ð´Ð»Ñ ÑÑÐ¾Ð³Ð¾ ÑÐ¸Ð¿Ð° ÑÐ¸Ð»ÑÑÑÐ°
  operators = [
    FilterOperator.CONTAINS,
    FilterOperator.NOT_CONTAINS,
    FilterOperator.EQUALS,
    FilterOperator.NOT_EQUALS
  ];

  @ViewChild('input', {static: true}) input: any;
  @ViewChild('grid', {static: true}) grid: any;
  @ViewChild('operatorMenu', {static: true}) operatorMenu: MenuComponent;

  public listColumns: Column[] = [
    new Column('checked', 'Checked', 45, ColumnType.CHECKBOX, ''), // Ð Ð½ÐµÐºÐ¾ÑÐ¾ÑÑÑ Ð¼ÐµÑÑÐ°Ñ ÑÐµÑÐºÐ¾ Ð·Ð°Ð´Ð°Ð½Ð¾ 28
    new Column('caption', this.intl.translate('(All)'), 250, ColumnType.STRING, '')
  ];

  // IFilter implementation
  // Initialization
  public init() {
    this.selectMode = this.filter.operator === FilterOperator.SET;
    if (this.selectMode) {
      this.filter.operator = FilterOperator.CONTAINS;
    }
    this.listColumns[1].type = this.filter.type;
    setTimeout(() => {
      if (!this.selectMode) {
        this.input.nativeElement.select();
        this.input.nativeElement.focus();
      }
    }, 50);
  }

  // Validation
  public validate(): boolean {

    this.inputError = '';
    this.gridError = '';

    let checkedItems: any[] = [];

    // Ð§Ð¸ÑÑÐ¸Ð¼ ÑÐ¿Ð¸ÑÐ¾Ðº Ð·Ð½Ð°ÑÐµÐ½Ð¸Ð¹ Ð² ÑÐ¸Ð»ÑÑÑÐµ
    this.filter.items.splice(0, this.filter.items.length);

    if (this.selectMode) {
      // Ð¥Ð¾ÑÑ Ð±Ñ Ð¾Ð´Ð½Ð¾ Ð·Ð½Ð°ÑÐµÐ½Ð¸Ðµ Ð½ÑÐ¶Ð½Ð¾ Ð¾ÑÐ¼ÐµÑÐ¸ÑÑ
      this.filter.operator = FilterOperator.SET;
      this.filter.items.splice(0, this.filter.items.length);
      checkedItems = this.items.filter(i => i.checked);
      if (checkedItems.length === 0) {
        this.gridError = 'Select values';
        return false;
      }
      checkedItems.forEach(i => this.filter.items.push(i.value));
    } else {
      // Ð¡Ð¾Ð´ÐµÑÐ¶Ð¸Ñ/Ð½Ðµ ÑÐ¾Ð´ÐµÑÐ¶Ð¸Ñ - Ð½ÑÐ¶Ð½Ð¾ Ð²Ð½ÐµÑÑÐ¸ Ð½Ðµ Ð¿ÑÑÑÑÑ ÑÑÑÐ¾ÐºÑ
      if (this.filter.operator === FilterOperator.CONTAINS ||
          this.filter.operator === FilterOperator.NOT_CONTAINS) {
        if (!this.filter.value) {
          this.inputError = 'Enter value';
          return false;
        }
      }
    }

    return true;
  }


  public noText(): boolean {
      return this.selectMode
      || this.filter.operator === FilterOperator.EMPTY
      || this.filter.operator === FilterOperator.NOT_EMPTY;
  }

  // ÐÐ¾Ð»ÑÑÐ°ÐµÐ¼ ÑÐ½Ð¸ÐºÐ°Ð»ÑÐ½ÑÐµ Ð·Ð½Ð°ÑÐµÐ½Ð¸Ñ ÐºÐ¾Ð»Ð¾Ð½ÐºÐ¸
  // Ð­ÑÐ¾Ñ ÐºÐ¾Ð´ Ð¼Ð¾Ð¶Ð½Ð¾ Ð²ÑÐ½ÐµÑÑÐ¸ Ð² Ð»Ð¸Ð±Ñ ÐºÐ°ÐºÑÑ-Ð½Ð¸Ð±ÑÐ´Ñ
  private getItems(): Promise<Array<{checked: boolean, value: any, displayedValue: string}>> {
    return new Promise((resolve) => {

      const field = this.filter.fieldName;
      const col = this.state.columnByFieldName(field);

      // ÐÐ¾Ð¿Ð¸ÑÑÐµÐ¼ Ð¼Ð°ÑÑÐ¸Ð², ÑÐ¾ÑÑÐ¸ÑÑÐµÐ¼, Ð¿ÐµÑÐµÐ±Ð¸ÑÐ°ÐµÐ¼
      this.rows.concat().sort((i1, i2) => {
        return i1[field] === null ? -1 : i2[field] === null ? 1 : i1[field] > i2[field] ? 1 : -1;
      }).forEach(row => {

        // ÐÐ½Ð°ÑÐµÐ½Ð¸Ðµ
        const v = row[field];
        const v_displayed = this.state.dataSource.displayedValue(col, v, row);

        // ÐÐ°Ð´Ð¿Ð¸ÑÑ
        let s = v_displayed === null ? '[empty]' : v_displayed;
        // ÐÐ¾Ð±Ð°Ð²Ð»ÑÐµÐ¼, ÐµÑÐ»Ð¸ ÑÐ°ÐºÐ¾Ð³Ð¾ Ð·Ð½Ð°ÑÐµÐ½Ð¸Ñ ÐµÑÐµ Ð½Ðµ Ð±ÑÐ»Ð¾
        if ((this._items.length === 0 || this._items[this._items.length - 1].value !== v)) {
          this._items.push({
            checked: this.filter.items.indexOf(v) >= 0,
            value: v,
            displayedValue: v_displayed,
            caption: s
          });
        }
      });
      resolve(this._items); // ÐÐ¾ÑÐ¾Ð²Ð¾
    });
  }

  _items: Array<any> = null;
  public get items(): Array<any> {
    if (this._items === null) {
      this._items = [];
      // ÐÐ°Ð¿Ð¾Ð»Ð½Ð¸Ð¼ Ð¸ Ð¾Ð±Ð½Ð¾Ð²Ð¸Ð¼ ÐµÑÐµ ÑÐ°Ð·
      setTimeout(() => {
        this.getItems().then(items => this.grid.updateData());
      }, 50);
    }
    return this._items;
  }

  // ÐÐµÑÐµÐºÐ»ÑÑÐµÐ½Ð¸Ðµ Ð² ÑÐµÐ¶Ð¸Ð¼ Ð²ÑÐ±Ð¾ÑÐ° Items Ð¸ Ð¾Ð±ÑÐ°ÑÐ½Ð¾
  toggleMode(e: any) {
    e.preventDefault();
    this.selectMode = !this.selectMode;
  }

  constructor(
    protected intl: InternationalizationService) {
    super(intl);
  }
}
